import React, { useEffect, useState } from "react";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import { CustomButton } from "../../../components/main_comps/custom_button";

import { useSelector } from "react-redux";
import CustomSelect from "../../../components/main_comps/custom_select";
import { useSnackbar } from "notistack";
import secureStorage from "../../../../services/secureStorage";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import { ADMIN_USER, APPROVED, CLIENT, RNC, RNCAPPROVED, STATUS_CODE_200 } from "../../../../utility/constants/valueConstants";
import { modififyDropdownServiceNameList } from "../../../../services/fetchDropdownListData";
import ApprovalContainer from "../../../components/ui_comps/approval_comps/ApprovalContainer";

///////test
const ChargeBackClient = ({ onNextClick }) => {
    const [loading, setLoading] = useState(false);
    const [payinServiceList, setPayinServiceList] = useState([]);
    const [serviceProviderName, setServiceProviderName] = useState("");
    // console.log(serviceProviderName, "serviceProviderName_______________1111");


    const role = secureStorage.getItem(SS_ROLE);

    const containerStyle = {
        backgroundColor: "#F3F3F3",
        alignSelf: "center",
        height: 55,
        width: "100%",
        boxShadow: "none",
        outline: "none",
        paddingLeft: 10,
        borderRadius: 5,
        boxSizing: "border-box",
        maxWidth: "auto",
    };






    // CHARGEBACK FUNCTIONS
    const fetchPayinDropDown = () => {
        ApiRequestGet.getAllServiceProviderList({
            type: "payin",
        })
            .then((res) => {
                if (res.statusCode === STATUS_CODE_200) {
                    setPayinServiceList(modififyDropdownServiceNameList(res.data));
                }
            })
            .catch((err) => { });
    };



    useEffect(() => {
        fetchPayinDropDown();
    }, []);
    return (
        <div
            style={{
                maxHeight: 500,
                overflow: "scroll",
                position: "relative",
            }}
            className="hide-scroll-bar"
        >
            <div style={{ marginTop: 20, width: "50%", minWidth: "400px", display: "flex", flexDirection: "column", justifyContent: "center", }}>
                <label style={{ fontSize: 14, fontSize: 14, lineHeight: 2, marginLeft: "30px", paddingBottom: 10 }}>
                    Select the Service Provider
                </label>
                <div style={{ maxWidth: "350px", marginLeft: "30px" }}>
                    <CustomSelect
                        // disabled={serviceType === "" ? true : false}
                        placeholder="Select Service Provider"
                        style={{
                            ...containerStyle,
                            position: "",
                        }}
                        value={serviceProviderName}
                        options={
                            payinServiceList ? payinServiceList

                                : ""
                        }
                        onChange={(data) => {
                            setServiceProviderName(data);
                        }}
                    />
                </div>
            </div>
            <div
                style={{
                    marginTop: 20,
                    display: "flex",
                    justifyContent: "space-around",
                    marginLeft: "15px",
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "white",
                }}
            >

                <CustomButton
                    textColor={"#000"}
                    title="Cancel"
                    backgroundColor="#DFDFDF"
                    styles={{ width: 150, color: "black" }}
                    onClick={() => {
                        onNextClick(false);
                    }}
                    loading={loading}
                />
                <CustomButton
                    title="Next"
                    backgroundColor="#38369C"
                    styles={{ width: 150 }}
                    onClick={() => {
                        onNextClick(true, serviceProviderName);
                    }}
                    loading={loading}
                />
            </div>
            <div
                style={{ width: "100%", maxHeight: 600, overflow: "auto" }}
                className="hide-scroll-bar"
            >



            </div>

        </div>
    );
};

export default ChargeBackClient;
